import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Drawer } from "antd";
import { useStores } from "@/store";
import { Button, Checkbox } from "@/components";
import VoucherItem from "@/pages/vouchers/components/Item";
import { Terms } from "@/pages/vouchers";
import { useObserver } from "mobx-react-lite";

const BASE_URL =
  process.env.REACT_APP_MODE === "PRODUTION"
    ? "https://book.diningcity.asia"
    : "https://staging-book.diningcity.asia";

/**
 * 餐厅详情
 *
 * PC和移动端使用不同的布局方式
 */
export const Vouchers = ({ show, offers, restaurant }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [terms, setTerms] = useState("");
  const [current, setCurrent] = useState("");
  useEffect(() => {
    if (show) {
      setVisible(true);
    }
  }, [show]);
  /**查看条款 */
  function showTerm(data) {
    setTerms(data.detail.desc);
    setVisible2(true);
  }
  /**查看详情并兑换 */
  function showDetail(data) {
    setVisible3(true);
    setCurrent(data);
  }
  return (
    <div className="page-restaurant--redeem">
      <Terms visible={visible2} setVisible={setVisible2} text={terms} />
      <Confirm
        visible={visible3}
        setVisible={setVisible3}
        voucher={current}
        restaurant={restaurant}
        showTerm={showTerm}
      />
      <List
        visible={visible}
        setVisible={setVisible}
        offers={offers}
        showDetail={showDetail}
        showTerm={showTerm}
      />
    </div>
  );
};

/**列表 */
const List = ({ visible, setVisible, offers, showDetail, showTerm }) => {
  const { t } = useTranslation();
  return (
    <Drawer
      className="reedem-history-drawer"
      placement="bottom"
      closable={false}
      height={305}
      destroyOnClose
      onClose={() => setVisible(false)}
      visible={visible}
    >
      <div className="reedem-history-details">
        <header>
          <h3>{t("VOUCHERS.Select voucher")}</h3>
        </header>
        <div
          className="scroll-view"
          style={{
            height: 210,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          {offers.map((item, index) => {
            return (
              <VoucherItem
                voucher={item}
                key={index}
                status="available"
                onSelect={() => showDetail(item)}
                showTerm={() => showTerm(item)}
              />
            );
          })}
        </div>
      </div>
    </Drawer>
  );
};

/**确认兑换 */
const Confirm = ({ restaurant, voucher, visible, setVisible, showTerm }) => {
  const { t } = useTranslation();
  const { restaurantStore, voucherStore } = useStores();
  const [accpet, setAccept] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);
  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);
  function onConfirm() {
    setLoading(true);
    console.log(count, accpet)
    // voucherStore.redeem(restaurant.id, {

    // })
  }
  return useObserver(() => {
    return voucher ? (
      <Drawer
        className="reedem-history-drawer"
        placement="bottom"
        closable={false}
        height={345}
        destroyOnClose
        onClose={() => setVisible(false)}
        visible={visible}
      >
        <div className="reedem-history-details">
          <header>
            <span
              className="icon icon-arrow-left"
              onClick={() => setVisible(false)}
            ></span>
            <h3>{t("VOUCHERS.Confirm redeem")}</h3>
            <span></span>
          </header>
          <VoucherItem
            voucher={voucher}
            status="available"
            showTerm={() => showTerm(voucher)}
            drinks={<Drinks points={voucher.points} onChange={setCount} />}
          />
          <Checkbox onChange={setAccept}>
            <span
              dangerouslySetInnerHTML={{
                __html: t("VOUCHERS.AGREE_PRIVACY_POLICY", {
                  privacyUrl: restaurantStore.privacyUrl,
                }),
              }}
            ></span>
            <a onClick={() => showTerm(voucher)}>{t("TERMS")}</a>
          </Checkbox>
          <footer>
            <Button onClick={() => setVisible(false)}>{t("CANCEL")}</Button>
            <Button
              type="primary"
              onClick={onConfirm}
              disabled={!accpet}
              loading={loading}
            >
              {t("CONFIRM")}
            </Button>
          </footer>
        </div>
      </Drawer>
    ) : null;
  });
};

const Drinks = ({ points, onChange }) => {
  const { t } = useTranslation();
  const [count, setCount] = useState(1);
  const max = Math.min(points, 99);
  useEffect(() => {
    onChange(count);
  }, [count]);
  function onBlur(ev) {
    const value = ev.target.value;
    if (!/^[0-9]{1,2}$/.test(value) || value < 1) {
      setCount(1);
    } else if (value > max) {
      setCount(max);
    } else {
      setCount(value);
    }
  }
  return (
    <div className="voucher-drinks-input">
      <label>{t("VOUCHERS.Drinks")}:</label>
      <span onClick={() => setCount(count - 1)} data-disabled={count < 2}>
        -
      </span>
      <input
        type="tel"
        onChange={(ev) => setCount(ev.target.value)}
        onBlur={onBlur}
        value={count}
      />
      <span onClick={() => setCount(count + 1)} data-disabled={count > 98}>
        +
      </span>
    </div>
  );
};
